// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueMeta from 'vue-meta'
// import axios from './util/http'
import appUtils from './util/appUtils'
import pubUtils from './util/pubUtils'
import VueWechatTitle from 'vue-wechat-title'
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.config.ignoredElements = ['wx-open-launch-weapp'] // 这句是main.js页面一定要写的
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer);
Viewer.setDefaults({
  Options: {
    "inline": false,
    "button": true,
    "navbar": false,
    "title": false,
    "toolbar": false,
    "tooltip": true,
    "movable": true,
    "zoomable": true,
    "rotatable": true,
    "scalable": true,
    "transition": false,
    "fullscreen": false,
    "keyboard": false,
    "url": "data-source"
  }
});

Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "D+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(Y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

// Raven
//   .config('https://3409d8f13d3d4071a083ff4610736bc2@error.jiankanghao.net/71')
//   .addPlugin(RavenVue, Vue)
//   .install();

Vue.prototype.$appUtils = appUtils
Vue.prototype.$pubUtils = pubUtils
Vue.use(Vant);
Vue.use(VueWechatTitle)
Vue.use(VueMeta)
// Vue.prototype.$axios = axios
// Vue.use(axios)

router.beforeEach((to, from, next) => {
  let udid = localStorage.getItem("udid")
  if (udid) {
    next();
  } else {
    var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    var res = "";
    var n = 15
    for (var i = 0; i < n; i++) {
      var id = Math.ceil(Math.random() * 35);
      res += chars[id];
    }
    localStorage.setItem("udid", res)
    next();
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js